export default { sha: '8edb95b30c3b642e598ff726f3fe3267b7b0e0ab', buildNumber: 'undefined' }
